<div class="imageContainer flex flex-column gap-3 surface-200 border-round-md">
  <div class="flex justify-content-center pt-4 pb-4 pl-3 pr-3">
    <img [src]="config()?.link" [alt]="config()?.labelDisplay" />
  </div>

  <div class="flex p-3 justify-content-between surface-50 border-round-bottom-md">
    <div class="flex flex-column">
      <span class="font-size-l font-semibold h-full">
        @if (!hideLabel()) {
          {{ config()?.labelDisplay }}
        }
      </span>

      <span class="font-size-sm">
        {{ "common.uploaded_at" | translate }}
        {{ convertToTimeString(config()?.uploadTimestamp) }}</span
      >
    </div>

    <div class="flex gap-4">
      <app-svg-icon
        class="pointer align-content-center"
        (click)="onOpenClick()"
        iconName="download"
        iconColor="primary"
      >
      </app-svg-icon>

      @if (!hideEdit()) {
        <app-svg-icon
          *appHasPermission="{
            permissions: [permissions.allPermissions.MEDIA_UPDATE],
          }"
          class="pointer align-content-center"
          (click)="onEditClick()"
          iconName="edit"
          iconColor="primary"
        >
        </app-svg-icon>
      }
      @if (!hideDelete()) {
        <app-svg-icon
          *appHasPermission="{
            permissions: [permissions.allPermissions.MEDIA_DELETE],
          }"
          class="pointer align-content-center"
          (click)="onDeleteClick($event)"
          iconName="trash"
          iconColor="primary"
        >
        </app-svg-icon>
      }
    </div>
  </div>
</div>
